import React from 'react'
import { Link } from 'react-router-dom'

function BlogLeft() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Blog Left Sidebar</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Blog </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start Blog --> */}
    <section className="section-padding bg-light-white our_articles">
      <div className="container">
        <div className="row">
          <h6 className="d-none">1</h6>
          <aside className="col-lg-4">
            <div className="sidebar_wrap mb-md-80">
              <div className="sidebar">
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Search</h5>
                  </div>
                  <form>
                    <div className="input-group group-form">
                      <input type="search" name="#" className="form-control form-control-custom" placeholder="Search"/>
                      <span className="input-group-append"> <i className="fas fa-search"></i> </span> </div>
                  </form>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Category</h5>
                  </div>
                  <ul className="categories custom">
                    <li> <Link to="#" className="text-custom-black fs-14">All <span className="text-light-dark">(122)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Family <span className="text-light-dark">(26)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Adventure <span className="text-light-dark">(66)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Romantic <span className="text-light-dark">(59)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Wildlife <span className="text-light-dark">(55)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Beach <span className="text-light-dark">(89)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Honey Moon <span className="text-light-dark">(27)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Parks <span className="text-light-dark">(67)</span></Link> </li>
                  </ul>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Popular Post</h5>
                  </div>
                  <ul className="custom popular_post">
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-1.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Repeat predefined chunks</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-2.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Making it look readable</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-4.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Best Rates For Taxi Service</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Install App and get free ride</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Recent Posts</h5>
                  </div>
                  <ul className="popular-post custom resend-banner sidebar-arrow arrow-layout-2">
                    <li className="post-box">
                      <div className="post-img p-relative mb-xl-20"> <Link to="blog-details.php"> <img src="/tm/react/bycycle/assets/images/team-2.jpg" className="full-width" alt="img"/> </Link>
                        <div className="post-meta text-center"> <Link to="#" className="btn-second btn-small mt-3">See All</Link> </div>
                      </div>
                      <p className="mb-xl-50">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    </li>
                    <li className="post-box">
                      <div className="post-img p-relative mb-xl-20"> <Link to="blog-details.php"> <img src="/tm/react/bycycle/assets/images/team-1.jpg" className="full-width" alt="img"/> </Link>
                        <div className="post-meta text-center"> <Link to="#" className="btn-second btn-small mt-3">See All</Link> </div>
                      </div>
                      <p className="mb-xl-50">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </aside>
          <div className="col-lg-8">
            <div className="row"> 
              <article className="col-md-6 post mb-xl-30">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-1.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Selecting The Proper Bicycle</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                    
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
            
              <article className="col-md-6 post mb-xl-30">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-2.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 30 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Michael Valenti Cycling.</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
             
              <article className="col-md-6 post mb-xl-30">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Tie—Bike Snob NYC</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
             
              <article className="col-md-6 post mb-xl-30">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-4.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Bangable Dudes Cycling</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
             
              <article className="col-md-6 post mb-sm-30">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-5.jpg" className="full-width" alt="img"/> </Link>
                  
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Red Kite Prayer</Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
             
              <article className="col-md-6 post">
                <div className="post-wrapper bx-wrapper">
                  <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-6.jpg" className="full-width" alt="img"/> </Link>
                
                  </div>
                  <div className="blog-meta padding-20 bg-custom-white p-relative">
                    <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                    <div className="post-heading">
                      <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Adventure Journal </Link> </h2>
                      <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                    </div>
                  </div>
                  <div className="post-footer">
                  
                    <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
                </div>
              </article>
            </div>
            <div className="row">
              <div className="col-12">
                <nav className="section-padding-top">
                  <ul className="pagination justify-content-center">
                    <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                    <li className="page-item active"><Link className="page-link" to="#">2</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                    <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default BlogLeft